import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { validateUrlCode } from '../../utils/api';

/**
 * Zentorga URL 라우팅 및 코드 검증 훅
 * URL 패턴: /:adNumber/:code (예: /A001/XYZ123)
 * @returns {{adNumber: string, code: string, codeInfo: object|null, loading: boolean, error: Error|null}}
 */
export const useZentorgaRouter = () => {
  const { adNumber, code } = useParams();
  const navigate = useNavigate();
  const [codeInfo, setCodeInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const validateCode = async () => {
      if (!adNumber || !code) {
        setLoading(false);
        setError(new Error('Missing adNumber or code in URL'));
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // URL 코드 검증
        const info = await validateUrlCode(code);

        // adNumber가 일치하는지 확인
        if (info.ad_number !== adNumber) {
          throw new Error('Ad number mismatch');
        }

        setCodeInfo(info);
      } catch (err) {
        console.error('Code validation error:', err);
        setError(err);
        // 검증 실패 시 홈으로 리디렉션
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    validateCode();
  }, [adNumber, code, navigate]);

  return { adNumber, code, codeInfo, loading, error };
};

export default useZentorgaRouter;
